import { Config } from '../_config'
import { BaseFetcher, FetchFunction } from './BaseFetcher'

export class WindowFetcher extends BaseFetcher {
  static create({ config, token }: { config: Config; token: string | undefined }) {
    return new WindowFetcher(config, token)
  }

  protected fetch() {
    return window.fetch as FetchFunction
  }
}
